module.exports = __webpack_public_path__ + "img/m2.8713f56d.png";